import React, { HTMLAttributes } from 'react'

import styles from './styles.module.css'

interface IAnimatedButtonProps extends HTMLAttributes<HTMLButtonElement> {};

export const AnimatedButton: React.FC<IAnimatedButtonProps> = ({ children, className, ...rest }) => {
  return (
    <button
      className={
        `
          ${styles['button-animation']} uppercase tracking-[.20em] font-semibold
          py-5 text-sm px-10 mt-8 hover:text-white
          bg-primary
          text-white
          desktop:bg-transparent
          desktop:text-gray-900
          ${className}
        `
      }
      {...rest}
    >
      {children}
    </button>
  )
}
